import React, {createContext, useState, useContext, useEffect, ReactNode} from 'react';

interface SnackbarProps {
  message: string;
  severity?: 'info' | 'success' | 'error' | 'copy';
  autoHideDuration?: number;
}

const SnackbarContext = createContext<SnackbarProps & {
  isOpen: boolean;
  openSnackbar: (props: SnackbarProps) => void;
  closeSnackbar: () => void;
}>({
  isOpen: false,
  message: '',
  severity: 'info',
  autoHideDuration: 3000,
  openSnackbar: () => {},
  closeSnackbar: () => {},
});

export const SnackbarProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<SnackbarProps['severity']>('info');
  const [autoHideDuration, setAutoHideDuration] = useState(3000);

  const openSnackbar = (props: SnackbarProps) => {
    console.log("props", props);
    
    setMessage(props.message);
    setSeverity(props.severity || 'info');
    setAutoHideDuration(props.autoHideDuration || 3000);
    setIsOpen(true);
  };

  const closeSnackbar = () => setIsOpen(false);

  useEffect(() => {
    if (isOpen) {
      const timeoutId = setTimeout(() => setIsOpen(false), autoHideDuration);
      return () => clearTimeout(timeoutId);
    }
  }, [isOpen, autoHideDuration]);

  return (
    <SnackbarContext.Provider
      value={{
        isOpen,
        message,
        severity,
        autoHideDuration,
        openSnackbar,
        closeSnackbar,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => useContext(SnackbarContext);
